export const bonus = [
  {
    title: '',
    img: './img/team/team_1.webp',
    alt: ''
  },
  {
    title: '',
    img: './img/team/team_2.webp',
    alt: ''
  },
  {
    title: '',
    img: './img/team/team_3.webp',
    alt: ''
  },
  {
    title: '',
    img: './img/team/team_4.webp',
    alt: ''
  },
]

export const founder = {
  title: 'Henry Médeau interviewé par Tua',
  video: './img/team/tua.mp4',
  alt: 'Interview d`\'Henry Médeau via la chaine Facebook Tua'
}

export const header = [
  {
    title: 'L\'équipe SeedOut Fenua !',
    img: './img/team/team.webp',
    alt: 'La team SeedOut fenua en texte gras!'
  },
  {
    title: 'Les gardiens travaillent pour vous !',
    img: './img/team/team_guardians.webp',
    alt: 'SeedOut Fenua Les gardiens travaillent pour vous !'
  },
]

export const teamAmbassador = [
  {
    firstName: 'Célia',
    lastName: 'Hodent',
    assignment: 'Game UX',
    img: './img/team/tikis/team_tiki_13.webp',
    linkedin: '',
    description: ''
  }
]

export const teamOfficial = [
  {
    firstName: 'Henry',
    lastName: 'Médeau',
    assignment: 'Fondateur - Game Conceptor',
    img: './img/team/tikis/team_tiki_10.webp',
    linkedin: '',
    description: ''
  },
  {
    firstName: 'Fabrice',
    lastName: 'Tirolien',
    assignment: 'Web Developer',
    img: './img/team/tikis/team_tiki_8.webp',
    linkedin: '',
    description: ''
  },
  {
    firstName: 'Jeoffrey',
    lastName: 'Delavennes',
    assignment: 'Game Developer',
    img: './img/team/tikis/team_tiki_4.webp',
    linkedin: '',
    description: ''
  },
  {
    firstName: 'Florient',
    lastName: 'Theunissen',
    assignment: 'Game Developer',
    img: './img/team/tikis/team_tiki_3.webp',
    linkedin: '',
    description: ''
  },
]

export const teamGuest = [
  {
    firstName: 'Sara',
    lastName: '',
    assignment: 'Game Designer',
    img: './img/team/tikis/team_tiki_6.webp',
    linkedin: '',
    description: ''
  },    {
    firstName: 'Hi\'ilei',
    lastName: '',
    assignment: 'Game Designer',
    img: './img/team/tikis/team_tiki_9.webp',
    linkedin: '',
    description: ''
  },    {
    firstName: 'Naiki',
    lastName: '',
    assignment: 'Game Designer',
    img: './img/team/tikis/team_tiki_7.webp',
    linkedin: '',
    description: ''
  },    {
    firstName: 'Vaiarii',
    lastName: '',
    assignment: 'Game Designer',
    img: './img/team/tikis/team_tiki_12.webp',
    linkedin: '',
    description: ''
  }
]
